export const data_limit = "10";
export const config_api = "/api/v1/config";
export const subscribe_api = "/api/v1/newsletter/subscribe";
export const placeApiAutocomplete_api = "/api/v1/config/place-api-autocomplete";
export const placedetails_api = "/api/v1/config/place-api-details";
//export const distance_api = "/api/v1/config/distance";
export const geocode_api = "/api/v1/config/geocode-api";
export const zoneId_api = "/api/v1/config/get-zone-id";
export const moduleList = "/api/v1/module";
export const banners = "/api/v1/banners";
export const others_banners = "api/v1/other-banners";
export const categories_api = "/api/v1/categories";
export const campaigns_item = "/api/v1/campaigns/item";
export const popular_items = "/api/v1/items/popular";
export const common_condition_api = "api/v1/common-condition";
export const common_conditions_product_api = "api/v1/common-condition/items";
export const popular_store_api = "/api/v1/stores/popular";
export const subCategories_api = "/api/v1/categories/childes";
export const most_reviewed_items_api = "/api/v1/items/most-reviewed";
export const latest_store_api = "/api/v1/stores/latest";
export const latest_items_api = "/api/v1/items/latest";
export const more_from_store = "/api/v1/items/related-store-items";
export const new_arrivals = "/api/v1/items/new-arrival";
export const flash_sales = "/api/v1/flash-sales";
export const flash_sales_items = "api/v1/flash-sales/items";
export const parcel_category_api = "/api/v1/parcel-category";
export const parcel_video_api = "api/v1/other-banners/video-content";
export const parcel_whyChoose_api = "api/v1/other-banners/why-choose";
export const distance_api = "/api/v1/config/distance-api";
export const new_arrival_stores_api = "/api/v1/stores/latest";
export const filtered_stores_api = "/api/v1/stores/get-stores";
export const top_rated_stores = "/api/v1/stores/top-rated";
export const store_details_api = "/api/v1/stores/details";
export const signUp_api = "/api/v1/auth/sign-up";
export const signIn_api = "/api/v1/auth/login";
export const guest_checkout = "api/v1/auth/guest/request";
export const profile_info = "/api/v1/customer/info";
export const store_item_search_api = "/api/v1/items/search";
export const parcel_delivery_instructions =
  "/api/v1/customer/order/parcel-instructions";
export const order_place_api = "/api/v1/customer/order/place";
export const my_orders_api = "/api/v1/customer/order";
export const user_info_api = "/api/v1/customer/info";
export const remove_account_api = "/api/v1/customer/remove-account";
export const profile_update_api = "/api/v1/customer/update-profile";
export const coupon_list_api = "/api/v1/coupon/list";
export const similar_product_api = "/api/v1/items/related-items";
export const discounted_product_api = "/api/v1/items/discounted";
export const discounted_stores_api = "/api/v1/stores/discounted";
export const popular_items_in_store = "/api/v1/stores/popular-items";
export const common_condition_product_in_store =
  "/api/v1/items/common-conditions";
export const wallet_transactions_list_api =
  "/api/v1/customer/wallet/transactions";
export const LP_transactions_list_api =
  "/api/v1/customer/loyalty-point/transactions";
export const Loyalty_points_transfer_api =
  "/api/v1/customer/loyalty-point/point-transfer";

export const address_list_api = "/api/v1/customer/address/list";
export const add_address_api = "/api/v1/customer/address/add";
export const update_address_api = "/api/v1/customer/address/update";
export const delete_address_api = "/api/v1/customer/address/delete";
export const refund_policy_api = "/refund";
export const product_reviews_api = "/api/v1/items/reviews";
export const add_wish_list_api = "/api/v1/customer/wish-list/add";
export const get_wish_list_api = "/api/v1/customer/wish-list";
export const delete_wish_list_api = "/api/v1/customer/wish-list/remove";
export const get_channel_list = "/api/v1/customer/message/list";
export const get_conversations_api = "/api/v1/customer/message/details";
export const store_message_api = "/api/v1/customer/message/send";
export const channel_search_api = "/api/v1/customer/message/search-list";
export const cm_firebase_token_api = "/api/v1/customer/cm-firebase-token";
export const suggestedProducts_api = "/api/v1/customer/suggested-items";
export const suggested_items_stores = "/api/v1/items/item-or-store-search";
export const order_details_api = "/api/v1/customer/order/details";
export const track_order_api = "/api/v1/customer/order/track";
export const order_cancel_api = "/api/v1/customer/order/cancel";
export const offline_payment_options = "/api/v1/offline_payment_method_list";
export const update_payment_method_api =
  "/api/v1/customer/order/payment-method";
export const refund_reasons_api = "/api/v1/customer/order/refund-reasons";
export const testimonial_api = "/api/v1/testimonial";
export const categories_details_api = "/api/v1/categories/items";
export const categories_details_Store_api = "/api/v1/categories/stores";
export const categories_Childes_api = "/api/v1/categories/childes";
export const basic_campaigns_api = "api/v1/campaigns/basic";
export const basic_campaigns_details_api =
  "/api/v1/campaigns/basic-campaign-details";
export const typewise_store_api = "/api/v1/stores";
export const social_login_api = "/api/v1/auth/social-login";
export const verify_phone_api = "/api/v1/auth/verify-phone";
export const social_register_api = "/api/v1/auth/social-register";
export const store_review_api = "/api/v1/stores/reviews";
export const submit_items_review_api = "/api/v1/items/reviews/submit";
export const submit_deliveryman_review_api =
  "/api/v1/delivery-man/reviews/submit";

export const update_interest_api = "/api/v1/customer/update-interest";
export const landing_page_api = "/api/v1/react-landing-page";
export const most_trips = "/api/v1/most-tips";

export const wallet_bonuses = "/api/v1/customer/wallet/bonuses";
export const add_fund_to_wallet = "api/v1/customer/wallet/add-fund";
export const product_review_api = "/api/v1/items/related-items";
export const item_add_to_cart = "api/v1/customer/cart/add";
export const cart_all_item_remove = "api/v1/customer/cart/remove";
export const all_cart_list = "api/v1/customer/cart/list";
export const cart_item_delete = "api/v1/customer/cart/remove-item";
export const cart_item_update = "api/v1/customer/cart/update";
export const last_item_review = "api/v1/customer/review-reminder";
export const cancel_last_item_review = "api/v1/customer/review-reminder-cancel";
